import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeadTagHuay from "../component/playlotteryComponent/HeadTagHuay";
import { numAddZero } from "../helper/numToFixed";
import ChoiceHuayType from "../component/playlotteryComponent/ChoiceHuayType";
import HuayType from "../component/playlotteryComponent/HuayType";
import Numpad from "../component/playlotteryComponent/Numpad";
import ResultBar from "../component/playlotteryComponent/ResultBar";
import ModalGetNumbebrSet from "../component/playlotteryComponent/ModalGetNumberSet";
import ModalGetBetCache from "../component/playlotteryComponent/ModalGetBetCache";
import ModalAlert from "../component/playlotteryComponent/ModalAlert"
import PreviousBar from "../component/PreviousBar";

const Countdown = (props) => {
  const [state, setState] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const id = setInterval(() => {
      const currentTime = new Date().getTime();
      const distanceToDate =
        new Date(localStorage.getItem("closeRoundDatetime")).getTime() -
        currentTime;

      let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      const numbersToAddZeroTo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

      days = `${days}`;
      if (numbersToAddZeroTo.includes(hours)) {
        hours = `0${hours}`;
      }
      if (numbersToAddZeroTo.includes(minutes)) {
        minutes = `0${minutes}`;
      }
      if (numbersToAddZeroTo.includes(seconds)) {
        seconds = `0${seconds}`;
      }
      // console.log(hours,minutes,seconds)
      if (hours < 0 && minutes < 0 && seconds < 0) {
        setState({ text: "ปิดรับแทง" });
        props.pushBack();
      } else {
        setState({
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        });
      }
    }, 1000);
    return () => {
      clearInterval(id);
    };
  }, []);

  return (
    <span className="">
      {state.text
        ? state.text
        : state.days == 0
        ? state.hours + ":" + state.minutes + ":" + state.seconds
        : state.days +
          " วัน " +
          state.hours +
          ":" +
          state.minutes +
          ":" +
          state.seconds}
    </span>
  );
};

const Playlottery = () => {
  const navigate = useNavigate();
  const [openTab, setOpenTab] = useState(0);
  const [huyType, sethuyType] = useState(localStorage.getItem("lotteryName").split(' ').includes("JACKPOT") ? 5 : 3);
  const [huayOption, sethuayOption] = useState(localStorage.getItem("lotteryName").split(' ').includes("JACKPOT") ? ["bon_5"] : ["bon_3"]);
  const [specialOption, setSpecialOption] = useState("");
  const [Number, setNumber] = useState(localStorage.getItem("lotteryName").split(' ').includes("JACKPOT")  ? ["", "", "", "", ""] : ["", "", ""]);
  const [lotteryName, setLotteryName] = useState(null);
  const [round, setRound] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [textAlert, setTextAlert] = useState("");
// console.log(huayOption)
  const changeHuayType = (i) => {
    // console.log(i);
    if (i === 6) {
      sethuayOption(["bon_6"]);
    } else if (i === 5) {
      sethuayOption(["bon_5"]);
    } else if (i === 4) {
      sethuayOption(["bon_4"]);
    } else if (i === 3) {
      sethuayOption(["bon_3"]);
    } else if (i === 2) {
      sethuayOption(["bon_2", "lang_2"]);
    } else if (i === 1) {
      sethuayOption(["bon_1"]);
    }
    sethuyType(i);
    setNumber(new Array(i).fill(""));
    setSpecialOption("");
  };

  const changeOption = (e) => {
    if (!e.target.id) return console.log("เทส");
    let huayOptions = [...huayOption];
    let check = huayOptions.filter((data) => data == e.target.id);
    if (check.length) {
      sethuayOption(huayOptions.filter((data) => data != e.target.id));
    } else {
      if (e.target.id == "tode_3" && specialOption == "reverse") {
        setSpecialOption("");
      }
      huayOptions.push(e.target.id);
      sethuayOption(huayOptions);
    }
  };

  const createTickets = (number, option) => {
    if (!huayOption.length) {
      setNumber(new Array(huyType).fill(""));
      setSpecialOption("");
      setShowAlert(true);
      setTextAlert("กรุณาเลือกประเภทหวย");
    }
    let prevTicket = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    let check_prevTicket = JSON.parse(
      localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
    );

    if (option == "double_number") {
      const allNumber = [
        "00",
        "11",
        "22",
        "33",
        "44",
        "55",
        "66",
        "77",
        "88",
        "99",
      ];
      allNumber.map((number) => {
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (option == "low_number") {
      const allNumber = [...Array(50).keys()];

      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (option == "high_number") {
      function range(start, end) {
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
      }
      const allNumber = range(50, 99);

      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (option == "odd_number") {
      const array = [...Array(100).keys()];
      const allNumber = array.filter((n) => n % 2);
      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (option == "even_number") {
      const array = [...Array(100).keys()];
      const allNumber = array.filter((n) => n % 2 == 0);
      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (specialOption == "reverse") {
      let findPermutations = (string) => {
        if (!string || typeof string !== "string") {
          return "Please enter a string";
        } else if (string.length < 2) {
          return string;
        }
        let permutationsArray = [];
        for (let i = 0; i < string.length; i++) {
          let char = string[i];

          if (string.indexOf(char) != i) continue;

          let remainingChars =
            string.slice(0, i) + string.slice(i + 1, string.length);

          for (let permutation of findPermutations(remainingChars)) {
            permutationsArray.push(char + permutation);
          }
        }
        return permutationsArray;
      };
      const allNumber = findPermutations(number.join(""));
      allNumber.map((number) => {
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (specialOption == "front_number") {
      function range(start, end) {
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
      }
      let num = number.join("");
      num = parseInt(num + "0");

      const allNumber = range(num, num + 9);

      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (specialOption == "back_number") {
      function range(start, end, range) {
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx * range);
      }

      let num = number.join("");
      num = parseInt(num);
      const allNumber = range(num, num + 9, 10);

      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else if (specialOption == "19_door") {
      function frontrange(start, end) {
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
      }
      function backrange(start, end, range) {
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx * range);
      }
      let num = number.join("");
      const back = backrange(parseInt(num), parseInt(num) + 9, 10);
      const front = frontrange(parseInt(num + "0"), parseInt(num + "0") + 9);
      const allNumber = front.concat(back);
      allNumber.map((number) => {
        number = numAddZero(number);
        for (let i = 0; i < huayOption.length; i++) {
          let tickets = {
            betAmount: 1,
            currency: "credit",
            lotteryNumber: number,
            lotteryRound: localStorage.getItem("roundId"),
            lotteryType: huayOption[i],
            member: localStorage.getItem("member"),
            rewardAmount: 0,
            rewardRate: 0,
          };
          let checkTickets = {
            betNumber: number,
            betType: huayOption[i],
            lotteryRound: localStorage.getItem("roundId"),
          };

          if (
            !prevTicket.find(
              (prevticket) =>
                prevticket.lotteryType == tickets.lotteryType &&
                prevticket.lotteryNumber == tickets.lotteryNumber
            )
          ) {
            prevTicket.push(tickets);
            check_prevTicket.push(checkTickets);
          }
        }
      });
    } else {
      const num = number.join("");
      for (let i = 0; i < huayOption.length; i++) {
        let tickets = {
          betAmount: 1,
          currency: "credit",
          lotteryNumber: num,
          lotteryRound: localStorage.getItem("roundId"),
          lotteryType: huayOption[i],
          member: localStorage.getItem("member"),
          rewardAmount: 0,
          rewardRate: 0,
        };
        let checkTickets = {
          betNumber: num,
          betType: huayOption[i],
          lotteryRound: localStorage.getItem("roundId"),
        };

        if (
          !prevTicket.find(
            (prevticket) =>
              prevticket.lotteryType == tickets.lotteryType &&
              prevticket.lotteryNumber == tickets.lotteryNumber
          )
        ) {
          prevTicket.push(tickets);
          check_prevTicket.push(checkTickets);
        }
      }
    }
    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(prevTicket)
    );
    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(check_prevTicket)
    );
    if (specialOption !== "reverse") {
      setSpecialOption("");
    }
    setNumber(new Array(huyType).fill(""));
  };

  const addTicketFromNumset = (data) => {
    let prevTicket = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    let check_prevTicket = JSON.parse(
      localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
    );
    if (lotteryName != "หวยรัฐบาลไทย") {
      data = data.filter(
        (data) => data.betType != "na_3" && data.betType != "lang_3"
      );
    }

    for (let i = 0; i < data.length; i++) {
      let tickets = {
        betAmount: data[i].betAmount || 1,
        currency: "credit",
        lotteryNumber: data[i].betNumber,
        lotteryRound: localStorage.getItem("roundId"),
        lotteryType: data[i].betType,
        member: localStorage.getItem("member"),
        rewardAmount: 0,
        rewardRate: 0,
      };
      let checkTickets = {
        betNumber: data[i].betNumber,
        betType: data[i].betType,
        lotteryRound: localStorage.getItem("roundId"),
      };

      if (
        !prevTicket.find(
          (prevticket) =>
            prevticket.lotteryType == tickets.lotteryType &&
            prevticket.lotteryNumber == tickets.lotteryNumber
        )
      ) {
        prevTicket.push(tickets);
        check_prevTicket.push(checkTickets);
      }
    }
    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(prevTicket)
    );
    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(check_prevTicket)
    );
    setNumber(new Array(huyType).fill(""));
  };

  const addTicketFromInvoice = (data) => {
    let prevTicket = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    let check_prevTicket = JSON.parse(
      localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
    );
    if (lotteryName != "หวยรัฐบาลไทย") {
      data = data.filter(
        (data) => data.betType != "na_3" && data.betType != "lang_3"
      );
    }

    for (let i = 0; i < data.length; i++) {
      let tickets = {
        betAmount: 1,
        currency: "credit",
        lotteryNumber: data[i].lotteryNumber,
        lotteryRound: localStorage.getItem("roundId"),
        lotteryType: data[i].lotteryType,
        member: localStorage.getItem("member"),
        rewardAmount: 0,
        rewardRate: 0,
      };
      let checkTickets = {
        betNumber: data[i].lotteryNumber,
        betType: data[i].lotteryType,
        lotteryRound: localStorage.getItem("roundId"),
      };

      if (
        !prevTicket.find(
          (prevticket) =>
            prevticket.lotteryType == tickets.lotteryType &&
            prevticket.lotteryNumber == tickets.lotteryNumber
        )
      ) {
        prevTicket.push(tickets);
        check_prevTicket.push(checkTickets);
      }
    }
    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(prevTicket)
    );
    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(check_prevTicket)
    );
    setNumber(new Array(huyType).fill(""));
  };

  const addNumber = (e) => {
    let array = [...Number];
    if (
      specialOption != "front_number" &&
      specialOption != "back_number" &&
      specialOption != "19_door"
    ) {
      if (!array[huyType - 1].length) {
        if (array[0] == "") {
          array[0] = e.target.value;
        } else if (array[1] == "") {
          array[1] = e.target.value;
        } else if (array[2] == "") {
          array[2] = e.target.value;
        } else if (array[3] == "") {
          array[3] = e.target.value;
        } else if (array[4] == "") {
          array[4] = e.target.value;
        } else if (array[5] == "") {
          array[5] = e.target.value;
        }
      }

      setNumber(array);

      if (array[huyType - 1].length) {
        setTimeout(function () {
          createTickets(array);
        }, 200);
      }
    } else {
      if (array[huyType - 1] == undefined) {
        if (array[0] == "") {
          array[0] = e.target.value;
        }
        setNumber(array);
        if (array[0].length) {
          setTimeout(function () {
            createTickets(array);
          }, 200);
        }
      }
    }
  };

  const deleteListTickets = (data) => {
    let check = false;

    if (data) {
      check = true;
    } else {
      check = window.confirm("คุณต้องการลบเลขทั้งหมด ?");
    }
    if (check) {
      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify([])
      );
      localStorage.setItem(
        `check_${localStorage.getItem("lotteryId")}`,
        JSON.stringify([])
      );
      setNumber(new Array(huyType).fill(""));
    }
  };

  const deleteListTickets2 = (data) => {
    let check = false;
    if (data == undefined) {
      if (data) {
        check = true;
      } else {
        check = window.confirm("คุณต้องการลบเลขทั้งหมด ?");
      }
    } else if (data.target.id) {
      if (data.target.id != "deleteAllTickets") {
        check = true;
      } else {
        check = window.confirm("คุณต้องการลบเลขทั้งหมด ?");
      }
    }
    if (check) {
      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify([])
      );
      localStorage.setItem(
        `check_${localStorage.getItem("lotteryId")}`,
        JSON.stringify([])
      );
      setNumber(new Array(huyType).fill(""));
    }
  };

  const deleteTicket = (data) => {
    let prevArray = [
      ...JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId"))),
    ];
    let prevCheckArray = [
      ...JSON.parse(
        localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
      ),
    ];

    prevArray = prevArray.filter(
      (ticket) =>
        ticket.lotteryNumber != data.lotteryNumber ||
        ticket.lotteryType != data.lotteryType
    );
    prevCheckArray = prevCheckArray.filter(
      (ticket) =>
        ticket.betNumber != data.lotteryNumber ||
        ticket.betType != data.lotteryType
    );

    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(prevArray)
    );
    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(prevCheckArray)
    );
    setNumber(new Array(huyType).fill(""));
  };

  const deleteNumber = (huayType) => {
    let array = [...Number];

    if (huayType > 4) {
      if (array[4] != "") {
        array[4] = "";
      } else if (array[3] != "") {
        array[3] = "";
      } else if (array[2] != "") {
        array[2] = "";
      } else if (array[1] != "") {
        array[1] = "";
      } else {
        array[0] = "";
      }
    } else if (huayType === 4) {
      if (array[3] != "") {
        array[3] = "";
      } else if (array[2] != "") {
        array[2] = "";
      } else if (array[1] != "") {
        array[1] = "";
      } else {
        array[0] = "";
      }
    } else {
      if (array[1] != "") {
        array[1] = "";
      } else {
        array[0] = "";
      }
    }

    setNumber(array);
  };

  const setSpecial = async (option) => {
    if (specialOption == option) {
      await setSpecialOption("");
      await setNumber(new Array(huyType).fill(""));
    } else {
      await setSpecialOption(option);
      if (
        option != "19_door" &&
        option != "front_number" &&
        option != "back_number" &&
        option != "reverse" &&
        huyType === 2
      ) {
        await createTickets([], option);
      } else {
        if (option == "reverse") {
          if (huayOption.filter((data) => data == "tode_3").length) {
            const huayNewOption = huayOption.filter((data) => data != "tode_3");
            sethuayOption(huayNewOption);
          }
          setNumber(new Array(huyType).fill(""));
        } else {
          setNumber(new Array(1).fill(""));
        }
      }
    }
  };

  const pushBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    localStorage.getItem("lotteryId") || navigate("/dashboard");
    let prevTicket = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    let check_prevTicket = JSON.parse(
      localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
    );
    if (prevTicket?.length && check_prevTicket?.length) {
      prevTicket.map(
        (data) => (data.lotteryRound = localStorage.getItem("roundId"))
      );
      check_prevTicket.map(
        (data) => (data.lotteryRound = localStorage.getItem("roundId"))
      );
    }
    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(prevTicket)
    );
    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(check_prevTicket)
    );

    setLotteryName(localStorage.getItem("lotteryName"));
    setRound(localStorage.getItem("Round"));

    const id = setInterval(() => {
      if (localStorage.getItem("lotteryName") != lotteryName) {
        return (
          alert("มีการเลือกหวยชนิดอื่น กรุณาเลือกหวยใหม่ค่ะ"),
          navigate("/dashboard")
        );
      } else {
        if (localStorage.getItem("Round") != round) {
          return (
            alert("มีการเลือกรอบหวยยี่กีอื่น กรุณาเลือกหวยใหม่ค่ะ"),
            navigate("/dashboard")
          );
        }
      }
    }, 5000);
    return () => clearInterval(id);
  }, [lotteryName, round]);

  return (
    <>
      {/* <PreviousBar2 name={lotteryName} /> */}
      <PreviousBar name={lotteryName}/>
      <ModalAlert open={showAlert} text={textAlert} setOpen={() => setShowAlert(false)} />
      <HeadTagHuay
        Countdown={<Countdown pushBack={pushBack} />}
        lotteryName={lotteryName}
        round={round}
      />
      {/* <div className="bg-white p-1">
        <ul className="w-auto grid gap-1 grid-cols-2 text-center mt-2 text-base">
          <li
            className={`${openTab === 0
              ? `text-defaultText2 border-defaultBorder `
              : `text-[#b3853e] `
              }w-auto border-b-2 pb-1 `}
          >
            <button
              onClick={() => {
                setOpenTab(0);
              }}
              data-toggle="option"
              href={`#option${0}`}
              role="tablist"
            >
              กดเลขเอง
            </button>
          </li>
          <li
            className={`${openTab === 1
              ? `text-defaultText2 border-defaultBorder `
              : `text-[#b3853e] `
              }w-auto border-b-2 pb-1 text-[#b3853e]`}
          >
            <button
              onClick={() => {
                setOpenTab(1);
              }}
              data-toggle="option"
              href={`#option${1}`}
              role="tablist"
            >
              เลือกจากแผง
            </button>
          </li>
        </ul>
      </div> */}
      <div className="bg-defaultButtonNumberPlay">
        <div className="grid grid-cols-5 gap-1 mx-1 my-0.5 md:grid-cols-5">
          <div className="col-span-5 md:col-span-5">
            <div className="rounded">
              <ChoiceHuayType changeHuayType={changeHuayType} type={huyType} />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-0.5 bg-white">
        <div className="col-span-2">
          <HuayType
            type={huyType}
            openTab={openTab}
            specialOption={specialOption}
            option={huayOption}
            setSpecial={setSpecial}
            createTickets={createTickets}
            onClick={(e) => changeOption(e)}
            lotteryName={lotteryName}
          />
        </div>
      </div>

      <div className="grid grid-cols-6 gap-0.5 bg-white">
        <div className="col-span-6">
          <Numpad
            type={huyType}
            index={openTab}
            specialOption={specialOption}
            Number={Number}
            huayOption={huayOption}
            onClickOption2={createTickets}
            onClickOption1={(e) => addNumber(e)}
            deleteNumber={() => deleteNumber(huyType)}
            deleteListTickets={() => deleteListTickets()}
          />
        </div>
      </div>
      <ResultBar
        deleteListTickets={deleteListTickets2}
        deleteListTicketsBtn={() => deleteListTickets2()}
        addTicketFromNumset={addTicketFromNumset}
        addTicketFromInvoice={addTicketFromInvoice}
        deleteTicket={deleteTicket}
      />

      <div className="container mx-auto mt-10 fixed inset-x-0 bottom-0 w-full bg-gradient-to-t from-[#b3853e] to-[#b3853e]">
        <div className=" grid grid-cols-3 gap-2 font-bold text-center">
          <div>
            <ModalGetNumbebrSet
              addTicketFromNumset={addTicketFromNumset}
              addTicketFromInvoice={addTicketFromInvoice}
            />
          </div>
          <div className="col-span-2">
            <ModalGetBetCache
              deleteListTickets={deleteListTickets}
              deleteTicket={deleteTicket}
              setShowAlert={setShowAlert}
              setTextAlert={setTextAlert}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Playlottery;
